import { client } from '../client';
import { IGMMessage } from './types/IGMMessage';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export interface SendMessagePayload {
  body: string;
  media_ids?: string[];
}

export const sendConversationMessage = async (
  conversationSid: string | undefined,
  payload: SendMessagePayload,
  userRole?: string,
): Promise<IGMMessage> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.post(`${prefix}/conversations/${conversationSid}/messages`, payload);
    return data;
  }
  try {
    const { data } = await client.post(`/conversations/${conversationSid}/messages`, payload);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.post(`${collectorPrefix}/conversations/${conversationSid}/messages`, payload);
      return data;
    }
    throw error;
  }
};
